export const visualizarCurriculo = function () {
    "use strict";

    var $divModal = '#modalVisualizar';
    var $modal = body.find($divModal);

    let _trocarIconeEmail = function () {
        let $icone = $modal.find('.curriculo-dados #dados-contato .bi-envelope-at');

        if ($icone.length) {
            $icone.removeClass('bi bi-envelope-at').addClass('fa fa-envelope-o');
        }
    }

    var _abrir = function () {
        window.global.loaderFull.show();
        $modal.find('.modal-body').load('/' + CULTURE_EMPREGARE + '/candidato/curriculo/visualizar', function () {
            window.global.loaderFull.hide();
            $modal.modal();
            _trocarIconeEmail();
        });

    };


    var init = function () {
        body.find('#btn-visualizar-curriculo').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });

    }

    return init();
};


